import React from "react";
import CardArticle from "../components/ArticlesComponents/ArticleCard";

const Article = () => {
  return (
    <div className="font-roboto">
      <section>
        <CardArticle />
      </section>
    </div>
  );
};

export default Article;
